






















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { StateChanger } from 'vue-infinite-loading'

@Component({
  components: {
    MessageHistoryDay: () =>
      import('@/components/message/MessageHistoryDay.vue'),
    InfiniteLoading: () => import('vue-infinite-loading'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MessageHistory extends Vue {
  $store!: ExStore

  get hasNext() {
    return this.$store.getters['message/hasHistoryNext']
  }

  get messages() {
    return this.$store.getters['message/dateMessages']
  }

  async beforeCreate() {
    await this.$store.dispatch('message/updateHistory')
    const latestId = this.$store.getters['message/latestNormalMessageUserId']
    try {
      if (latestId) {
        await this.$api.message.patchRead({ id: latestId })
      }
      this.$store.dispatch('message/updateUnreadHistory')
    } catch (e) {
      console.error(e)
    }
  }

  onNextLoad($state: StateChanger) {
    this.$store.dispatch('message/loadNextHistory').then(() => {
      if (this.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    })
  }
}
